import * as React from "react";

export default class THead extends React.Component {
  public render() {
    return <thead className="thead">{this.props.children}</thead>;
  }
}
